import { adaptiveCenterModalOptions } from '@psl/appComponents/ModalWrapper';
import { wrapNavigatorScreen } from '@psl/functions/navigation/utils/wrapNavigatorScreen';
import { CardStyleInterpolators } from '@react-navigation/stack';
import { lazy } from 'react';

const OrderStatusUpdatedPageContent = lazy(
  () => import('../components/OrderStatusUpdatedPageContent'),
);

export const OrderStatusUpdatedPage = wrapNavigatorScreen(
  OrderStatusUpdatedPageContent,
  adaptiveCenterModalOptions(() => ({
    headerTitleAlign: 'center',
    gestureEnabled: false,
    headerShown: false,
    headerStatusBarHeight: undefined,
    cardStyleInterpolator: CardStyleInterpolators.forModalPresentationIOS,
    cardStyle: { backgroundColor: 'transparent' },
  })),
);
